import React from 'react'
import  Navbar  from '../inc/Navbar'

import unicornriverside from "../images/UNICORN RIVERSIDE RESORT JUL 26-images-0.jpg"
import BrochureNew from './BrochureNew';
import CommentSection from './CommentSection';
function Riverside() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
  <br/>
        <br/>

          <div className="album py-1">
                <div className="container">
                  <div className="row ">
                    <div className="col-md-6 mt-3">
                                             <img src={unicornriverside} className="card-img-top" alt="unicornriverside"/>

       
                        </div>
                         <div className="col-md-6 mt-3">
         <h2>Own a Resort. <b>Earn More.</b></h2>
        <h5>🌊 What if your property could pay you every month? 💰</h5>
        <h6 className='nearairpotkolkata mb-2'>Stop investing in assets that just sit idle.</h6>
        <h6 className='nearairpotkolkata mb-2'>✨ Own a premium resort property at Unicorn Riverside Resort and unlock the potential of high rental income with a nominal investment.</h6>
        <h6 className='mb-3'>🏡 Whether you're looking for a weekend retreat or a smart investment, this is your chance to own a property that offers:</h6>
        
        <p className='mb-1'> ✅ High Rental Income Potential</p>
        <p className='mb-1'> ✅ Luxury Resort Lifestyle

        </p>
        <p className='mb-1'>✅ Scenic Riverside Location</p>
        <p className='mb-1'>✅ Strong Future Appreciation</p>
        <p className='mb-1'>✅ Perfect for Holiday Rentals & Family Vacations</p>
            <p className='mb-32'>✅ Limited Premium Inventory</p>
        <h6>📈 Invest today. Earn tomorrow. Build wealth for the future.</h6>
        <br/>
        <p>Don't miss this opportunity to own a premium riverside property before prices increase!
</p>
        <h6 className='nearairpotkolkata mb-3'><b>📍 Book your site visit today!
</b> 
       </h6>
        <h5>📞 Call / WhatsApp: <a href='tel: 7550967009'> 7550967009</a></h5>
    
        <h6 className='mb-2'>👤 Suman Biswas | Novesta Group</h6>


        
        <BrochureNew/>
        <br/>
                <p>💬 Comment "INTERESTED" or send us a direct message to receive complete project details and schedule your site visit.</p>
<CommentSection/>
      
                        </div>
                        </div>
                        </div>
                    </div>
                    <br/>
                    
    </div>
  )
}

export default Riverside